import ListItem from '../utils/ListItem';

function PhotosListItem(props) {
  return (
    <ListItem
      to={{ pathname: props.link, from: window.location.pathname + window.location.search }}
      primary={props.descr}
      secondary={props.country}
      meta={props.source}
    />
  );
}

export default PhotosListItem;
